import { FC } from 'react';
import HitlistUpsellComponent from './HitlistUpsellComponent';
import { WithAlert } from '@components/design';
import { feedback } from '@ecosystem/newron-design-system';

const { ActionType } = feedback;

const HitlistUpsellContainer: FC = () => (
  <div className="my-4 bg-white" data-testid="hitlist-upsell-container">
    <WithAlert
      title={<HitlistUpsellComponent text="These filter options only available with Full Hitlist subscription." />}
      type="info"
      actionType={ActionType.DEFAULT}
    />
  </div>
);

export default HitlistUpsellContainer;
